import { permissionsRol as analyticsRol } from 'app/policies/roles/analyticsRol.access';
import { PATH_ANALYTIC_AMPLITUDE } from 'app/router/routesConfigAnalyticAmplitude';

export function analytics({ flags, path, user }) {
  if (PATH_ANALYTIC_AMPLITUDE === path) {
    return analyticsRol(user).readList && flags?.showAmplitude;
  }

  return true;
}
